const pad = (str, len, padding = '0') =>
  `${str}${(new Array(len)).fill(padding).join('')}`.slice(0, len);

export default pad;